import { createContext } from 'react';

import { FeatureFlagsContextType } from './types';

export const FEATURE_FLAGS_CONTEXT = createContext<FeatureFlagsContextType>({
  featureFlagAvailability: {},
});

export const { Provider: FeatureFlagsProvider } = FEATURE_FLAGS_CONTEXT;
